// Weight is stored in pounds, always. The column is called Weight LBS and every
// downstream reader - the quote, the chassis rating, the overweight flag - assumes
// pounds, so a kilogram that reached storage would be wrong by a factor of 2.2 and
// look perfectly plausible.
//
// Customers do not all work in pounds, though, and typing a converted number from
// a phone calculator is where the transcription errors come from. So the editor
// takes kilograms when asked and converts on the way in (Alan, 2026-08-03): the
// unit is an input choice, never a stored one.

export const POUNDS_PER_KILOGRAM = 2.20462;

export function weightUnitLabel(unit) {
  return unit === 'kg' ? 'KG' : 'LBS';
}

/**
 * Returns pounds, rounded to a whole pound, or null when the input is not a
 * usable positive number. Rounding matches what the field already accepts - it
 * validates as a positive number and nobody weighs a container to the ounce.
 */
export function poundsFromWeightInput(value, unit = 'lbs') {
  const numeric = typeof value === 'number'
    ? value
    : typeof value === 'string' && /^\d+(?:\.\d+)?$/u.test(value.trim())
      ? Number(value.trim())
      : NaN;
  if (!Number.isFinite(numeric) || numeric <= 0) return null;
  const pounds = unit === 'kg' ? numeric * POUNDS_PER_KILOGRAM : numeric;
  const rounded = Math.round(pounds);
  return rounded > 0 && rounded <= 1_000_000 ? rounded : null;
}
